import { render, staticRenderFns } from "./BottomWave.html?vue&type=template&id=7a6f6c93&scoped=true&"
import script from "./BottomWave.vue?vue&type=script&lang=js&"
export * from "./BottomWave.vue?vue&type=script&lang=js&"
import style0 from "./BottomWave.scss?vue&type=style&index=0&id=7a6f6c93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a6f6c93",
  null
  
)

export default component.exports